/** Hardcoded banner badges z prototypu (fáze 1 — bez číselníku). */
export const BANNER_BADGES = [
  'BESTSELLER',
  'BEST RATED',
  'RECOMMENDED',
  'NEW',
  'PROMOTION',
  'LAST MINUTE',
] as const;

export type BannerBadge = (typeof BANNER_BADGES)[number];
